import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal, Button } from 'react-bootstrap';

import useTemplate from 'components/Common/Templates/Hooks/useTemplate';
import Spinner from 'components/Admin/Templates/Widgets/Spinner';
import actions from 'components/Admin/Templates/Actions';

import Details from './Details';

export default function Modal({
  row, show, onClose, onHide,
}) {
  const template = useTemplate(row.id);
  const [programsToClose, setProgramsToClose] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closePrograms = () => {
    setIsSubmitting(true);

    actions.close(
      template.id,
      programsToClose,
      (statuses) => {
        setIsSubmitting(false);
        onClose(statuses);
        onHide();
      },
    );
  };

  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Close Program</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        {template ? (
          <>
            <Details
              template={template}
              programsToClose={programsToClose}
              setProgramsToClose={setProgramsToClose}
            />

            <footer className="text-center mt20">
              <Button
                bsStyle="primary"
                className="btn-outline width-120 mr10"
                onClick={onHide}
                disabled={isSubmitting}
              >
                Cancel
              </Button>

              <Button
                bsStyle="primary"
                onClick={closePrograms}
                disabled={isSubmitting || programsToClose.length === 0}
              >
                Close & Mark as Completed
              </Button>
            </footer>
          </>
        ) : (
          <Spinner />
        )}
      </BaseModal.Body>
    </BaseModal>
  );
}

Modal.propTypes = {
  row: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
